export const getLabel = theme => theme && theme.label
